import React, { useState } from 'react';
import config from '../config';

export const FloatingChatWidget = () => {
  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <>
      {/* Mobile View - Fixed Bottom Bar (< 768px) */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-[9999] bg-white shadow-2xl border-t-2 border-gray-200">
        <div className="flex w-full">
          {/* Call Now Button - Left */}
          <a
            href={`tel:${config.contact.phone}`}
            className="flex-1 bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-4 px-4 flex items-center justify-center space-x-2 transition-all duration-300 active:scale-95"
          >
            <span className="text-xl">📞</span>
            <span className="text-sm sm:text-base">CALL NOW</span>
          </a>

          {/* Text Us Button - Right */}
          <a
            href={`sms:${config.contact.phone}`}
            className="flex-1 bg-gradient-to-br from-cyan-500 to-teal-600 hover:from-cyan-600 hover:to-teal-700 text-white font-bold py-4 px-4 flex items-center justify-center space-x-2 transition-all duration-300 active:scale-95 border-l-2 border-white"
          >
            <span className="text-xl">💬</span>
            <span className="text-sm sm:text-base">TEXT US NOW</span>
          </a>
        </div>
      </div>

      {/* Desktop View - Floating Chat Widget (>= 768px) */}
      <div 
        className="hidden md:block fixed bottom-6 right-6 z-[9999] transition-all duration-300 ease-in-out"
        style={{ maxWidth: isMinimized ? '60px' : '320px' }}
      >
        {/* Minimized State - Small Circle Button */}
        {isMinimized ? (
          <button
            onClick={() => setIsMinimized(false)}
            className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 flex items-center justify-center text-white text-2xl hover:scale-110 animate-pulse"
            aria-label="Open chat support"
          >
            💬
          </button>
        ) : (
          /* Expanded State - Chat Widget */
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 animate-slideUp">
            {/* Header / Title Bar */}
            <div className="bg-gradient-to-r from-cyan-500 to-teal-600 px-4 py-3 flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div className="w-2.5 h-2.5 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-white font-semibold text-sm">
                  Need Cleaning?
                </span>
              </div>
              <button
                onClick={() => setIsMinimized(true)}
                className="text-white hover:bg-white/20 rounded-full p-1 transition-colors"
                aria-label="Minimize chat"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
            </div>

            {/* Body / Content */}
            <div className="p-5 bg-gradient-to-b from-gray-50 to-white">
              {/* Message Bubble */}
              <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 mb-4">
                <p className="text-gray-700 text-sm leading-relaxed mb-2">
                  👋 Hi! Looking for professional cleaning services?
                </p>
                <p className="text-gray-600 text-xs">
                  Call us now for a <span className="font-semibold text-cyan-600">free quote</span>!
                </p>
              </div>

              {/* Call Now Button */}
              <a
                href={`tel:${config.contact.phone}`}
                className="block w-full bg-gradient-to-r from-cyan-500 to-teal-600 hover:from-cyan-600 hover:to-teal-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center transform hover:scale-105 group"
              >
                <span className="flex items-center justify-center space-x-2">
                  <span className="text-xl group-hover:animate-bounce">📞</span>
                  <span>CALL NOW</span>
                </span>
                <span className="block text-xs mt-1 font-normal opacity-90">
                  {config.contact.phoneDisplay}
                </span>
              </a>

              {/* Alternative Action */}
              <div className="mt-3 text-center">
                <a
                  href={config.hcp.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-cyan-600 hover:text-cyan-700 underline transition-colors"
                >
                  Or book online
                </a>
              </div>
            </div>

            {/* Footer Badge */}
            <div className="bg-gray-50 px-4 py-2 border-t border-gray-100">
              <p className="text-[10px] text-gray-500 text-center">
                💯 Available Mon-Sat • Fast Response
              </p>
            </div>
          </div>
        )}

        {/* Custom Animation Styles */}
        <style jsx>{`
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .animate-slideUp {
            animation: slideUp 0.3s ease-out;
          }
        `}</style>
      </div>
    </>
  );
};
